import { useState } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function NewsletterSubscribe({ source = 'blog' }){
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | ok | already | err
  const [err, setErr] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){
      setErr('Please enter a valid email.');
      return;
    }
    setStatus('loading');
    try {
      const res = await fetch(`${API}/api/newsletter/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, source }),
      });
      const data = await res.json();
      if (!res.ok || !data.ok) throw new Error(data.detail || 'Something went wrong');
      setStatus(data.already_subscribed ? 'already' : 'ok');
    } catch (e2){
      setStatus('err');
      setErr(e2.message || 'Please try again');
    }
  };

  if (status === 'ok' || status === 'already'){
    return (
      <div className="newsletter-block newsletter-success reveal" data-testid="newsletter-success">
        <div className="newsletter-eyebrow">Journal · Subscribe</div>
        <h3>
          {status === 'ok' ? 'You\u2019re on the list.' : 'Already subscribed.'}
        </h3>
        <p>
          {status === 'ok'
            ? 'We\u2019ll email you the moment the next visa-policy shift lands \u2014 not before.'
            : 'Nothing to do here \u2014 the next update will land in your inbox when it ships.'}
        </p>
      </div>
    );
  }

  return (
    <div className="newsletter-block reveal">
      <div className="newsletter-eyebrow">Journal · Subscribe</div>
      <h3>Get the next update <em>before your consulate does.</em></h3>
      <p>One email per meaningful policy change across the 41 programmes we track. No filler, no drip campaigns.</p>
      <form onSubmit={submit} className="newsletter-form" data-testid="newsletter-form">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          aria-label="Email address"
          className="newsletter-input"
          disabled={status === 'loading'}
          data-testid="newsletter-email"
          required
        />
        <button
          type="submit"
          className="newsletter-button"
          disabled={status === 'loading'}
          data-testid="newsletter-submit"
        >
          {status === 'loading' ? 'Adding\u2026' : 'Subscribe'}
        </button>
      </form>
      {err && <div className="newsletter-error" data-testid="newsletter-error">{err}</div>}
      <div className="newsletter-fineprint">We never share your email. Unsubscribe in one click.</div>
    </div>
  );
}
